import { IDiamond } from "types/diamond.types"
import { IDiamondFilter } from "types/diamondFilter.types"
import { shapes } from "./diamond-attributes"

export const getCanonicalUrlForDiamondSearchPage = (state: IDiamondFilter) => {
  if (typeof window !== 'undefined') {
    const origin = window.location.origin
    const diamondType = state.labCreated ? 'lab-created-diamonds' : 'natural-loose-diamonds'
    const shape = shapes[state.shape as keyof typeof shapes].toLowerCase().replace(/\s/g, '_')
    return `${origin}/${diamondType}/${shape}-diamonds`
  } else {
    return null
  }
}

export const getCanonicalUrlForDiamondShowPage = (diamond: IDiamond) => {
  if (typeof window !== 'undefined') {
    const origin = window.location.origin
    const diamondType = diamond.labcreated ? 'lab-created-diamonds' : 'natural-loose-diamonds'
    const carat = diamond.weight
    const shape = shapes[diamond.shape as keyof typeof shapes].toLowerCase().replace(/\s/g, '_')
    const cut = diamond.cut ? diamond.cut.toLowerCase().replace(/\s/g, '_') : ''
    const clarity = diamond.clarity ? diamond.clarity.toLowerCase() : ''
    const color = diamond.color ? diamond.color.toLowerCase() : ''
    return `${origin}/${diamondType}/${carat}-carat/${shape}-diamonds/${cut}-cut/${clarity}-clarity/${color}-color`
  } else {
    return null
  }
}